// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IMoneyTransferResponseDto } from './IMoneyTransferResponseDto';
import {
    IMoneyTransferResponseDtoFromJSON,
    IMoneyTransferResponseDtoFromJSONTyped,
    IMoneyTransferResponseDtoToJSON,
    IMoneyTransferResponseDtoToJSONTyped,
} from './IMoneyTransferResponseDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageMoneyTransferResponseDto
 */
export interface IPageMoneyTransferResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageMoneyTransferResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageMoneyTransferResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageMoneyTransferResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IMoneyTransferResponseDto>}
     * @memberof IPageMoneyTransferResponseDto
     */
    content?: Array<IMoneyTransferResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageMoneyTransferResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageMoneyTransferResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageMoneyTransferResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageMoneyTransferResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageMoneyTransferResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageMoneyTransferResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageMoneyTransferResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageMoneyTransferResponseDto interface.
 */
export function instanceOfIPageMoneyTransferResponseDto(value: object): value is IPageMoneyTransferResponseDto {
    return true;
}

export function IPageMoneyTransferResponseDtoFromJSON(json: any): IPageMoneyTransferResponseDto {
    return IPageMoneyTransferResponseDtoFromJSONTyped(json, false);
}

export function IPageMoneyTransferResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageMoneyTransferResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IMoneyTransferResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageMoneyTransferResponseDtoToJSON(json: any): IPageMoneyTransferResponseDto {
    return IPageMoneyTransferResponseDtoToJSONTyped(json, false);
}

export function IPageMoneyTransferResponseDtoToJSONTyped(value?: IPageMoneyTransferResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IMoneyTransferResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

